import React from 'react';
import './style/lib/animate.css';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {persistStore, persistCombineReducers} from 'redux-persist';
import storage from 'redux-persist/es/storage';
import {PersistGate} from 'redux-persist/es/integration/react'
// import {createLogger} from 'redux-logger';
import rootReducers from './reducers';
import rootSaga from './sagas';
import CRouter from './routes';
import mqtt from 'mqtt'
import {MQTT_URL} from './constants/configValues'

// const logger = createLogger({
//   // Ignore `CHANGE_AUTH_FORM` actions in the logger, since they fire after every keystroke
//   predicate: (getState, action) => action.type !== 'CHANGE_AUTH_FORM'
// })

const config = {
  key: 'homeOn',
  storage,
  blacklist: ['mqtt', 'presentation', 'device', 'camera', 'account', 'group', 'statistic', 'belllight']
}
const reducer = persistCombineReducers(config, rootReducers)

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const store = createStore(reducer, applyMiddleware(...middleware));

const persistor = persistStore(store);
const mqttClient = mqtt.connect(MQTT_URL, {})
sagaMiddleware.run(rootSaga, {mqttClient});

ReactDOM.render(<Provider store={store}>
  <PersistGate persistor={persistor}>
    <CRouter store={store}/>
  </PersistGate>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js